import { useAbsAlert, useAbsConfirm } from "commons/popup/store/absPopupHook";
import Button from "components/ui/Button";
import { rdxPopupOpen } from "commons/popup/store/popupR";
import { useDispatch } from "react-redux";
import { ButtonColor, ButtonSize } from "components/ComponentsType";
import { ButtonState, type IButton, type PopupCallBackParam } from "commons/popup/store/absPopupVo";
import { PopupType } from "./PopupType";
import {
  AlertPopupButtonGroup,
  ConfirmPopupButtonGroup,
  DeletePopupButtonGroup,
  type IconPopupProps,
} from "./display/IconPopup";

const commonButton = {
  color: ButtonColor.PRIMARY,
  btnSize: ButtonSize.MANAGE_POPUP_2,
  ellipsis: true,
  // maxWidth: "115px",
};

const ImageVwButton = {
  color: ButtonColor.WHITE,
  btnSize: ButtonSize.IMAGE_VIEW,
  ellipsis: true,
  maxWidth: "253px",
};
export interface IProductCallBack<U> {
  state: boolean;
  list: Array<U>;
}
export function useAlert(width?: string | number) {
  const { alert } = useAbsAlert(Button, width);
  return alert;
}

export function useConfirm() {
  const { confirm } = useAbsConfirm(Button);
  return confirm;
}

export function useCheckPopup() {
  const dispatch = useDispatch();
  const showCheckPopup = async (
    title: string,
    content: {
      year: number;
      month: number;
      total_price: number;
      is_realtime: boolean;
    },
    status: boolean,
    editFlag: boolean,
  ) => {
    dispatch(
      rdxPopupOpen({
        type: PopupType.CHECK_POPUP,
        width: 1180,
        data: {
          title,
          content,
          status,
          editFlag,
        },
      }),
    );
  };
  return { showCheckPopup };
}

export function useImageViewPopUp() {
  const dispatch = useDispatch();
  const showImageView = async (
    title?: string,
    image?: JSX.Element,
    buttons?: IButton[],
    callBack?: (state: PopupCallBackParam) => void,
  ) => {
    dispatch(
      rdxPopupOpen({
        type: PopupType.IMAGE_VIEW,
        width: 523,
        data: {
          title,
          image,
          buttons: buttons || [
            {
              ...ImageVwButton,
              text: "닫기",
              state: ButtonState.NO,
            },
          ],
        },
        isClose: true,
        callBack: callBack,
      }),
    );
  };
  return { showImageView };
}
export function useErrorPopup() {
  const dispatch = useDispatch();
  const errorPopup = async (msgErr?: string, buttons?: IButton[]) => {
    dispatch(
      rdxPopupOpen({
        type: PopupType.IERROR_POPUP,
        data: {
          msgErr,
          buttons: buttons || [
            {
              ...commonButton,
              text: "확인",
              state: ButtonState.NO,
            },
          ],
        },
      }),
    );
  };
  return { errorPopup };
}

/**
 * Icon을 사용한 레이어팝업 (타입별 버튼컴포넌트 디자인이 다름)
 */
export function useIConPopup() {
  const dispatch = useDispatch();
  const IconPopup = async (
    buttonType: "alert" | "confirm" | "delete" = "alert",
    data?: IconPopupProps,
    title?: string,
    callBack?: (v?: ButtonState) => void,
  ) => {
    const ButtonComponent = () => {
      switch (buttonType) {
        case "delete":
          return DeletePopupButtonGroup;
        case "confirm":
          return ConfirmPopupButtonGroup;
        case "alert":
        default:
          return AlertPopupButtonGroup;
      }
    };

    dispatch(
      rdxPopupOpen({
        width: 400,
        type: PopupType.ICON,
        title: title,
        data,
        callBack: callBack,
        buttonWrapper: ButtonComponent(),
      }),
    );
  };

  return IconPopup;
}
